import React from "react";

import TextBlock from "../components/general/text/TextBlock";
import { ASText } from "../assets/data/TextBlocks";

function ASPage() {
    return (
      <div id="Access_Page">
        <TextBlock blocks={ASText}></TextBlock>
      </div>
    );
  }
  
  export default ASPage;